var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35527 1.48002L8.64966 4.81286L1.26786 4.81286C1.06361 4.81286 0.899999 4.98007 0.899999 5.18385L0.899999 5.81615C0.899999 6.01993 1.06361 6.18713 1.26786 6.18713L8.64966 6.18713L5.35527 9.51999C5.21216 9.66477 5.21217 9.89903 5.35526 10.0438L5.35527 10.0438L5.79721 10.4909C5.94096 10.6364 6.1745 10.6363 6.31826 10.4909L6.31827 10.4909L10.9927 5.76191C11.1358 5.61713 11.1358 5.38287 10.9927 5.23807L10.9927 5.23807L6.31825 0.50909C6.31825 0.509087 6.31825 0.509085 6.31825 0.509082C6.1745 0.363639 5.94095 0.363639 5.79721 0.509082C5.79721 0.509085 5.79721 0.509088 5.7972 0.50909L5.35527 0.956185C5.21216 1.10097 5.21217 1.33522 5.35526 1.48002L5.35527 1.48002Z",
    fill: "#00A0F3",
    stroke: "#00A0F3",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLines);
export default __webpack_public_path__ + "static/media/ArrowLeftLines.0a5fb816.svg";
export { ForwardRef as ReactComponent };